export enum GroupShareDialogCloseEnum {
    Cancel = 1,
    CreateGroupShare = 2,
    EditGroupShare = 3
}